import React from 'react'

import { Text, Flex } from '@aws-amplify/ui-react'
import * as model from '@mytmpvpn/mytmpvpn-common/models/vpn'
import { VpnWithMetrics } from '../../pages/Home'
import { Copy } from '../Common'


export function VpnId({ vpnWithMetrics, expandedId }: { vpnWithMetrics: VpnWithMetrics, expandedId: boolean }) {
  const id = vpnWithMetrics.vpnId
  const compressedId = model.compressVpnId(vpnWithMetrics)
  return <Flex>
    <Text fontFamily={'monospace'}>{expandedId ? id : compressedId}</Text> <Copy children={id} />
  </Flex>
}
